<template>
	<div class="map-part">
		<bigTitle mClass="mClass" :bigtitle="bigtitle" />
		<div class="flex part-1">
			<divBox1 title="电池类型占比">
				<myEchart
					v-if="batteryTypeShow"
					:id="'BatteryType'"
					:options="batteryTypeOptions" />
			</divBox1>
			<divBox1 title="车牌品牌">
				<myEchart
					v-if="cheliangBrandShow"
					:id="'CheliangBrand'"
					:options="cheliangBrandOptions" />
			</divBox1>
			<divBox1 title="车辆型号">
				<myEchart
					v-if="cheliangModelShow"
					:id="'CheliangModel'"
					:options="cheliangModelOptions" />
			</divBox1>
			<divBox1 title="车辆新增入网趋势">
				<myEchart
					v-if="cheliangNetworkAccessShow"
					:id="'CheliangNetworkAccess'"
					:options="cheliangNetworkAccessOptions" />
			</divBox1>
		</div>
	</div>
</template>

<script>
import divBox1 from '../divBox1'
import bigTitle from '../bigTitle'
import myEchart from './../charts/echarts'
import { dataInterface } from '@/api/dataInterfaceApi'
import * as echarts from 'echarts5'

export default {
	components: {
		divBox1,
		myEchart,
		bigTitle
	},
	data() {
		return {
			bigtitle: {
				CHN: '交通指标',
				ENG: 'Traffic indicators',
			},
			// 电池类型占比
			batteryTypeOptions: {},
			batteryTypeShow: false,
			// 车辆品牌
			cheliangBrandOptions: {},
			cheliangBrandShow: false,
			// 车辆车型
			cheliangModelOptions: {},
			cheliangModelShow: false,
			// 车辆入网趋势
			cheliangNetworkAccessOptions: {},
			cheliangNetworkAccessShow: false,
		};
	},
	props: {
		cdata: {
			type: Object,
			default: () => ({})
		},
	},
	watch: {},
	mounted() {},
	methods: {
		// 刷新接口需要每个子组件封装一个getData();
		getData(data) {
			console.log('sf123123123123123123123', data)
			// 电池类型对比
			this.batteryType(data)
			// 车辆品牌
			this.cheliangBrand(data)
			// 车辆车型
			this.cheliangModel(data)
			// 车辆入网趋势
			this.cheliangNetworkAccess(data)
		},

		// 电池类型对比
		batteryType(data = {}) {
			let params = {}
			params = {
				'enCode': 'quanguo_shengshi-电池类型占比',
				'@ADCODE': (data ? data.province || data.city || data.adcode : '') || '000000'
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res || !res.length) return
				let data = res
				let seriesData = []
				data.map(item => {
					seriesData.push({
						value: parseFloat(item.battery_num || 0) * 100,
						name: item.battery_type + ' ' + (parseFloat(item.battery_num || 0) * 100) + '%'
					})
				})
				this.batteryTypeOptions = {
					color: ['#3174FC', '#11B5EF', '#F5EF50', '#91E679'],
					tooltip: {
						trigger: 'item'
					},
					legend: {
						top: '50%',
						// bottom: 0,
						left: 'left',
						orient: 'vertical',
						itemWidth: 10,
						itemHeight: 10,
						textStyle: {
							color: '#fff'
						},
					},
					series: [{
						name: '',
						type: 'pie',
						left: '20%',
						radius: ['20%', '50%'],
						avoidLabelOverlap: false,
						emphasis: {
							label: {
								show: true,
								fontSize: 40,
								fontWeight: 'bold'
							}
						},
						data: seriesData
					}]
				}
				this.batteryTypeShow = true
			})
		},

		// 车辆品牌
		cheliangBrand(data = {}) {
			let params = {}
			let query = this.$route.query
			params = {
				'enCode': 'quanguo_shengshi-车辆品牌',
				'@VEHICLE_TYPE': query.vehicle == '1' ? '乘用车' : (query.vehicle == '2' ? '商用车' : '全部'),
				'@ADCODE': (data ? data.province || data.city || data.adcode : '') || '000000'
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res || !res.length) return;
				let data = res.sort(function(a, b) { return b.vehicle_num - a.vehicle_num})
				let xAxisData = []
				let seriesData = []
				data.map( item => {
					xAxisData.push(item.vehicle_brand),
					seriesData.push({
						value: parseInt(item.vehicle_num, 10),
						// itemStyle: {
						// 	borderRadius: 5,
						// }
					})
				})
				this.cheliangBrandOptions = {
					title: {
						text: '辆'
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					xAxis: [{
						type: 'category',
						data: xAxisData
					}],
					yAxis: [{
						type: 'value'
					}],
					series: [{
						name: '数量',
						type: 'bar',
						barWidth: 20,
						itemStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{ offset: 0, color: '#83bff6' },
								{ offset: 0.5, color: '#188df0' },
								{ offset: 1, color: '#213EEB' }
							])
						},
						emphasis: {
							itemStyle: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
									{ offset: 0, color: '#2378f7' },
									{ offset: 0.7, color: '#2378f7' },
									{ offset: 1, color: '#83bff6' }
								])
							}
						},
						data: seriesData
					}]
				}
				this.cheliangBrandShow = true
			})
		},

		// 车辆车型
		cheliangModel(data = {}) {
			let params = {}
			let query = this.$route.query
			params = {
				'enCode': 'quanguo_shengshi-车辆车型',
				'@VEHICLE_TYPE': query.vehicle == '1' ? '乘用车' : (query.vehicle == '2' ? '商用车' : '全部'),
				'@ADCODE': (data ? data.province || data.city || data.adcode : '') || '000000'
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res || !res.length) return;
				let data = res.sort(function(a, b) { return b.vehicle_num - a.vehicle_num})
				let xAxisData = []
				let seriesData = []
				data.map( item => {
					xAxisData.push(item.vehicle_model),
					seriesData.push({
						value: parseInt(item.vehicle_num, 10),
						// itemStyle: {
						// 	borderRadius: 5,
						// }
					})
				})
				this.cheliangModelOptions = {
					title: {
						text: '辆',
						top: '3%',
						left: '2%',
						textStyle: {
							color: '#b3b3c9'
						}
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					// grid: {
					// 	left: '3%',
					// 	right: '4%',
					// 	bottom: '3%',
					// 	containLabel: true
					// },
					xAxis: [{
						type: 'category',
						data: xAxisData
					}],
					yAxis: [{
						type: 'value'
					}],
					series: [{
						name: '数量',
						type: 'bar',
						barWidth: 20,
						itemStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{ offset: 0, color: '#60F5FF' },
								{ offset: 1, color: '#3FA4FF' }
							])
							// color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
							// 	{ offset: 0, color: '#83bff6' },
							// 	{ offset: 0.5, color: '#188df0' },
							// 	{ offset: 1, color: '#188df0' }
							// ])
						},
						emphasis: {
							itemStyle: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
									{ offset: 0, color: '#2378f7' },
									{ offset: 0.7, color: '#2378f7' },
									{ offset: 1, color: '#83bff6' }
								])
							}
						},
						data: seriesData
					}]
				}
				this.cheliangModelShow = true
			})
		},
		
		// 车辆入网趋势
		cheliangNetworkAccess(data = {}) {
			let params = {}
			let query = this.$route.query
			params = {
				'enCode': 'quanguo_shengshi-车辆新增入网趋势',
				'@VEHICLE_TYPE': query.vehicle == '1' ? '乘用车' : (query.vehicle == '2' ? '商用车' : '全部'),
				'@ADCODE': (data ? data.province || data.city || data.adcode : '') || '000000'
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res) return;
				let data = res
				let xAxis = []
				let yAxis = []
				data.map(item => {
					xAxis.push(item.cur_month)
					yAxis.push(item.new_net_vehicle_number)
				})
				this.cheliangNetworkAccessOptions = {
					title: {
						text: '辆',
						top: '3%',
						left: '2%',
						textStyle: {
							color: '#b3b3c9'
						}
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							label: {
								backgroundColor: '#6a7985'
							}
						}
					},
					// grid: {
					// 	left: '3%',
					// 	right: '4%',
					// 	bottom: '3%',
					// 	containLabel: true
					// },
					xAxis: [{
						type: 'category',
						boundaryGap: false,
						data: xAxis
					}],
					yAxis: [{
						type: 'value'
					}],
					series: [{
						name: '入网车辆',
						type: 'line',
						stack: 'Total',
						smooth: true,
						lineStyle: {
							width: 2,
							color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
									offset: 0,
									color: 'RGBA(61, 161, 255, 1)'
								},
								{
									offset: 1,
									color: 'RGBA(52, 41, 240, 1)'
								}])
						},
						areaStyle: {
							opacity: 0.8,
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: 'rgba(101, 97, 240, 0.42)'
							},
							{
								offset: 1,
								color: 'rgba(118, 206, 255, 0)'
							}])
						},
						emphasis: {
							focus: 'series'
						},
						data: yAxis
					}]
				}
				this.cheliangNetworkAccessShow = true
			})
			.catch((err) => {
				console.log(err)
			});
		},

	}
}
</script>

<style lang="scss" scoped>
@import './part.scss';
</style>